import { FooterData , FileUrl, LogoData} from "../../../hooks/useApiCalls";
 
 
function Footer() {

  const footer_data = FooterData();

  const footer_text = footer_data.footer_text ? footer_data.footer_text : {};
  const footer_link = footer_data.links ? footer_data.links : [];
  const social_media = footer_data.social_media ? footer_data.social_media : [];

  const logodata = LogoData();

    return ( 
       <>
        <footer className="footer text-white py-5">
        <div className="container">
          <div className="row footer-content text-center text-md-start">
            <div className="col-md-3 footer-section logo mb-4 mb-md-0">
            <img width={50} src={FileUrl("images/"+logodata.logo)} /> 
            </div>
            <div className="col-md-3 footer-section about mb-4 mb-md-0">
              <h5>About Us</h5>
              <p>{footer_text.about}</p>
            </div>
            <div className="col-md-3 footer-section links mb-4 mb-md-0">
              <h5>Quick Links</h5>
              <ul className="list-unstyled">
                {footer_link.map((data)=>{
                  return <li><a href={data.link} className="text-white">{data.text}</a></li>;
                })}
              </ul>
            </div>
            <div className="col-md-3 footer-section social mb-4 mb-md-0">
              <h5>Follow Us</h5>
              <div className="d-flex justify-content-center justify-content-md-start">
                
              {social_media.map((data)=>{
                  return <a href={data.link} className="text-white me-3"><i className={data.icon} /></a>;
                })}
              </div>
            </div>
          </div>
          <div className="footer-bottom text-center mt-4">
            <p className="mb-0">{footer_text.footer_info}</p>
          </div>
        </div>
      </footer>
    </> 
 );

}

export default Footer;